/**
 * 전화번호 입력창 공용 포매터(국가 KR 고정). 사용자 화면의 모든 전화번호 입력창이 이걸로 실시간 하이픈을 붙인다.
 *
 * `formatPhoneAsYouType("01012345678")` → "010-1234-5678", "0101234" → "010-1234", "021234567" → "02-123-4567".
 * 숫자 외 문자는 지우고 11자리까지만 받으므로 붙여넣기("010 1234 5678", "+82 10-1234-5678")도 같은 결과가 된다.
 * 끝에 하이픈을 만들지 않아 맨 뒤에서 백스페이스로 지울 때 하이픈이 되살아나지 않는다.
 *
 * ★ 010 번호를 10자리까지 쳤을 때는 libphonenumber 가 옛 10자리 형식(010-123-4567)으로 보여 주다가
 *   11자리째에 010-1234-5678 로 바뀐다. 한 글자 동안의 흔들림이라 그대로 둔다.
 * ★ 화면값은 하이픈 포함이다. 서버가 숫자만 받는 폼(/play·/play1·/play3·/play4)은 상태에 `toPhoneDigits` 결과를
 *   들고 화면에만 포맷해 보여 준다. 랜딩·도입 문의 폼은 검증 규칙(`applyForm.ts` PHONE)이 하이픈을 허용해 그대로 보낸다.
 */
import { AsYouType } from "libphonenumber-js";

const MAX_DIGITS = 11;

/** 숫자만 남기고 11자리로 자른다. 국가번호(+82)로 시작하면 국내 형식(0…)으로 바꾼다. */
export const toPhoneDigits = (raw: string): string => {
  let digits = raw.replace(/\D/g, "");
  if (digits.startsWith("82") && digits.length > MAX_DIGITS) digits = `0${digits.slice(2)}`;
  return digits.slice(0, MAX_DIGITS);
};

/** 입력 중인 값을 "010-1234-5678" 형태로 만든다. */
export const formatPhoneAsYouType = (raw: string): string =>
  new AsYouType("KR").input(toPhoneDigits(raw));
